import React from 'react'
import {Col, Row, Table} from "antd";
import '../../../css/print.css'

class PurchaseDetailItems extends React.Component {

    render() {
        return (
            <React.Fragment>
                <div>
                    <Row justify={'center'}>
                        <h3>Sipariş Formu</h3>
                    </Row>
                    <Row>
                        <Col span={4}>
                            <p className={'font-bold'}>Ödeme:</p>
                            <p className={'font-bold'}>Kur:</p>
                            <p className={'font-bold'}>Kime:</p>
                            <p className={'font-bold'}>Satın Alma No:</p>
                            <p className={'font-bold'}>Reçete Adı:</p>
                        </Col>
                        <Col span={12}>
                            <p>{this.props.abstractInfo.payment}</p>
                            <p>{this.props.abstractInfo.currencyInfo}</p>
                            <p>{this.props.abstractInfo.whom}</p>
                            <p>{this.props.abstractInfo.purchaseNumber}</p>
                            <p>{this.props.abstractInfo.recipe}</p>
                        </Col>
                    </Row>
                    <Table size={'small'} columns={this.props.tableColumns} dataSource={this.props.tableData} pagination={false} />
                    <Row justify={'end'} style={{marginTop: '32px'}}>
                        <Col span={4}>
                            <span className={'font-bold'}>Toplam</span>: {this.props.subTotal.toFixed(3)}
                        </Col>
                    </Row>
                </div>
            </React.Fragment>
        )
    }
}
export default PurchaseDetailItems